import {Component, Input, OnInit} from '@angular/core'
import {DashboardItem} from '../iface'
import {VendorsEtc} from '../../../shared/services/cache.etc/vendors'
import {MlVsService} from '../../../shared/components/ml-vendor.search/ml.vs.service'
import {environment} from '../../../../environments/environment'
import {Router} from '@angular/router'
import {DashboardService} from '../dashboard.service'

@Component({
    selector: 'app-dashboard-details',
    templateUrl: 'dd.component.html',
    styleUrls: ['dd.component.css'],
    standalone: false
})
export class DashboardDetailsComponent implements OnInit {
  @Input() category: string
  @Input() items: DashboardItem[]
  sortedItems: DashboardItem[] = []
  inputCounter: number
  loading = true
  selectionAndResolveProcess: boolean
  systemCategory: string

  edit(item: DashboardItem, entity: string) {
    this.selectionAndResolveProcess = true
    this.DS.getVendorDataToSelect(item.vendor).then(res => {
      console.log('res: ', res)
      this.MLS.setVendor(res).subscribe(() => {
        const url = (entity === 'schedules') ? ((environment.isHotel(item.vendor)) ? 'hotel-schedules' : entity) : entity
        this.router.navigate([`/${url}`])
      })
    }, error => {
      console.log('error: ', error)
    })
  }

  constructor(
    private DS: DashboardService,
    private VS: VendorsEtc,
    private MLS: MlVsService,
    private router: Router
  ) {
  }

  ngOnInit() {
    console.log('init dd component', this)
    this.inputCounter = (this.items) ? this.items.length : 0
    if (this.inputCounter === 0) {
      console.log('input counter 0')
      return
    }
    // handle system category for navigation
    const cat = environment.categoryDec2Str(this.category).api
    console.log('try to init vendor names for - ', cat)
    this.systemCategory = (this.category === 'Hotel') ? 'hotels' : this.category
    this.VS.getVendorByCategory(cat).then(res => {
      console.log('dd got data: ', res)
      this.sortedItems = this.items.map(v => {
        const vendor = res.find(f => environment.compareVendor(v.vendor, f.vendor))
        v.name = (vendor) ? vendor.name : 'EMPTY NAME'
        return v
      })
      this.loading = false
    }, error => {
      console.log('dd error: ', error)
      this.loading = false
    })
  }
}
